import React from 'react';
import classNames from 'classnames';

import Select from '../../components/select';
import TranslationIds from '../../../commons/translationIds';

const ageGroupData = [
    { value: '<18', label: '<18', code: '<18'},
    { value: '18-24', label: '18-24', code: '18-24' },
    { value: '25-34', label: '25-34', code: '25-34' },
    { value: '35-44', label: '35-44', code: '35-44' },
    { value: '45-54', label: '45-54', code: '45-54' },
    { value: '55-64', label: '55-64', code: '55-64' },
    { value: '65+', label: '65+', code: '65+' },
];

const defaultValue = '-';

function renderAgeGroup (p) {
    const {
        fields,
        fieldErrors,
        setSubscribersFields,
        classes,
        translate,
        subscribersFields,
        touched,
    } = p;

    if (!fields || (!fields.dob)) {
        return (<React.Fragment></React.Fragment>);
    }
    
    function getLabel () {
        if (fields.dob && fields.dob === 1) {
            return `${translate(TranslationIds.REGISTRATION_LABEL_AGE_GROUP)}*`;
        }
        return translate(TranslationIds.REGISTRATION_LABEL_AGE_GROUP);
    }
    
    function getHelperText () {
        if (fieldErrors.age_group && fields.dob === 1) {
            return translate(TranslationIds.REGISTRATION_REQUIRED_AGE_GROUP);
        }
        return '';
    }
 

    function getValue () {
        if (!subscribersFields.age_group) {
            return defaultValue;
        }
        return subscribersFields.age_group;
    }

    function getData () {
        if(!touched.age_group || getValue() === defaultValue) {
            return [
                { label: `${translate(TranslationIds.REGISTRATION_SELECT)} ${translate(TranslationIds.REGISTRATION_LABEL_AGE_GROUP)}`, value: defaultValue},
                ...ageGroupData,
            ];
        }
        return ageGroupData;
    }

    return (
        <Select
            className={classNames(['ecal-reg-field-age_group', classes.selectUI])}
            placeHolder={getLabel()}
            helperText={getHelperText()}
            labelHeading={getLabel()}
            value={getValue()}
            dataProvider={getData()}
            onChange={(e, value) => {
                setSubscribersFields({
                    age_group: value,
                });
            }}
            name={'age_group'}
            error={fieldErrors.age_group}
        />
    );
}

export default renderAgeGroup;